import React from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import { getCreatorsByIds } from '../utils/oshiThemes';
import OshiShareClient from '../components/OshiShareClient';

const OshiSharePage = () => {
  const [searchParams] = useSearchParams();
  const idsParam = searchParams.get('ids') || '';
  const idList = idsParam ? idsParam.split(',').slice(0, 3) : [];
  const selected = getCreatorsByIds(idList);

  if (selected.length !== 3) {
    return <Navigate to="/oshi3" replace />;
  }

  const shareUrl = `${window.location.origin}/oshi3/share?ids=${idList.join(',')}`;
  const tweetText = encodeURIComponent(
    `✨ 私の #STPR推しメン3 ✨\n\n${selected[0].name} / ${selected[1].name} / ${selected[2].name}\n\nあなたの推しメンは？👇\n#STPR推しメン3\n${shareUrl}`
  );
  const tweetUrl = `https://twitter.com/intent/tweet?text=${tweetText}`;

  return <OshiShareClient selected={selected} tweetUrl={tweetUrl} />;
};

export default OshiSharePage;
